<!--
 * @Author: Suroc
 * @Date: 2024-07-05 14:49:39
 * @LastEditTime: 2024-12-31 10:04:39
 * @Description: 公共导航底部
-->

<template>
  <div class="footer" :class="themeClass">
    <div class="item_tabbar" @click="changeRouter(item)" v-for="(item, index) in navItems" :key="index"
      :style="{ left: index * 20 + '%' }">
      <div class="item_up_icon" :style="{ backgroundImage: `url('${item.img}')` }"></div>
      <div class="item_low_icon" :class="{ active: currentRouteName === item.path }">
        {{ $t(`nongC.${item.ncNane}`) }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router'
import { navStore, useThemeStore } from '@/stores/settings'
let router = useRouter()
const route = useRoute()
let NavStore = navStore()
let ActiveNav = computed(() => NavStore.activeNav)
const themeStore = useThemeStore()
let themeClass = computed(() => themeStore.theme)

import image1 from "@/assets/nong/tabbar_1.png"
import image2 from "@/assets/nong/tabbar_2.png"
import image3 from "@/assets/nong/tabbar_3.png"
import image4 from "@/assets/nong/tabbar_4.png"
import image5 from "@/assets/nong/tabbar_5.png"
const navItems = [
  { text: 'Home', path: '/home', img: image1, ncNane: "Home" },
  { text: 'Mining', path: '/miningmachine', img: image2, ncNane: "Farm" },
  { text: 'Profit', path: '/profit', img: image3, ncNane: "Trade" },
  { text: 'NFT', path: '/flst', img: image4, ncNane: "NFT" },
  { text: 'Team', path: '/team', img: image5, ncNane: "Mine" },
]
const currentRouteName = ref(navItems[0].text)
watchEffect(() => {
  currentRouteName.value = route.path
})

const changeRouter = (item) => {
  setTimeout(() => {
    router.replace(item.path)
  }, 100);
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
